<template>
   <form class="container ">
        <div class="form-group">
            <label>Title</label>
            <input type="text" class="form-control" v-model="name">
        </div>
        <div class="form-group">
            <label >Image</label>
            <input type="file" class="form-control"  @change="onChangeFile" >
        </div>
        <div class="form-group">
            <label for="exampleInputPassword1">Description</label>
            <textarea type="text" rows="10" class="form-control" v-model="description" ></textarea>
        </div>
         <div class="form-group">
            <label>Url</label>
            <input type="text" class="form-control" v-model="url">
        </div>
        <button type="submit" class="btn btn-light me-2" @click.prevent="UpdateSlider">Update</button>
        <button type="button" class="btn btn-light" @click ="$emit('cancel' , {})" >Cancel</button>
    </form> 
</template>
<script>

import axios from "axios";
import APIs from "@/../config";
export default {
    name: "UpdateSlider" ,
    data() {
        return {
            image : "" , 
            name : "" , 
            description: "",
            url :""
        }
    },
    async created(){
        const url = APIs.API_IMAGES + "/" + this.slider.imgFile
        const fileName = 'myFile.jpg'
        await fetch(url)
        .then(async response => {
            const contentType = response.headers.get('content-type')
            const blob = await response.blob()
            const file = new File([blob], fileName, { contentType, type: "image/jpeg" })
            // access file here
            this.image = file
        })
        this.name = this.slider.name
        this.description = this.slider.description
        this.url = this.slider.url
    },
    props : {
        slider : Object
    },
       methods : {
        onChangeFile(event) {
        this.image = event.target.files[0]
        },
        UpdateSlider(){
            const fd = new FormData()

            fd.append('imgFile' , this.image)
            fd.append('name' , this.name)
            fd.append('description' , this.description)
            fd.append('url' , this.url)

            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')
            axios.put(`${APIs.API_URL}/slider/${this.slider._id}/${user_id}/`, fd,{
                headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${get_token}`
                }
            })
            .then(()=> {
                 this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: "Updated",
                    showConfirmButton: false,
                    timer: 1500
                });
                this.$emit('refresh')
            })
            .catch((error) => {
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.error,
                    showConfirmButton: false,
                    timer: 1500
                });
            })
        }
    }
}
</script>










<!-- 
<template>
   <form class="container ">
        <div class="form-group">
            <label>Title</label>
            <input type="text" class="form-control" v-model="name" >
        </div>
        <div class="form-group">
            <label >Image</label>
            <input type="file" class="form-control"  @change="onChangeFile" name="file">
        </div>
        <div class="form-group">
            <label for="exampleInputPassword1">Description</label>
            <textarea type="text" class="form-control" v-model="this.description" ></textarea>
        </div>
        <div class="form-group">
            <label>URL</label>
            <input type="text" class="form-control" v-model="url" >
        </div>
        <button type="submit" class="btn btn-light me-2" @click.prevent="UpdateSlider">Update</button>
        <button type="button" class="btn btn-light" @click ="$emit('cancel' , {})" >Cancel</button>
    </form> 
</template>
<script>

import axios from "axios";
import APIs from "@/../config";
export default {
    name: "UpdateSlider" ,
    data() {
        return {
            name : "" ,
            imgFile : "" , 
            description: "",
            url :""
        }
    },
    async created(){
        const url = APIs.API_IMAGES + "/" + this.slider.imgFile
        const fileName = 'myFile.jpg'
        await fetch(url)
        .then(async response => {
            const contentType = response.headers.get('content-type')
            const blob = await response.blob()
            const file = new File([blob], fileName, { contentType, type: "image/jpeg" })
            // access file here
            this.imgFile = file
        })
        this.name = this.slider.name
        this.description = this.slider.description
        this.url = this.slider.url
    },
    props : {
        slider : Object
    },
       methods : {
        onChangeFile(event) {
        this.imgFile.push(event.target.files[0])
        }, 
        UpdateSlider(){
            const fd = new FormData()

            fd.append('name' , this.name)
            fd.append('imgFile' , this.imgFile)
            fd.append('description' , this.description)
            fd.append('url' , this.url)

            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')
            axios.put(`${APIs.API_URL}/slider/${this.slider._id}/${user_id}/`, fd,{
                headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${get_token}`
                }
            })
            .then(()=> {
                 this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: "Updated",
                    showConfirmButton: false,
                    timer: 1500
                });
                this.$emit('refresh')
            })
            .catch((error) => {
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.error,
                    showConfirmButton: false,
                    timer: 1500
                });
            })
        }
    }
}
</script> -->